import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, initTrafficSource, setGaUserId } from './analytics';
import { getUser } from './authStorage';

const PageViewTracker = () => {
  const location = useLocation();
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      initTrafficSource();
      const user = getUser();
      if (user?.cid) setGaUserId(user.cid);
    }
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

export default PageViewTracker;
